/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Live_Items_ChangedInputs */

const en_live_items_changed = /** @type {(inputs: Live_Items_ChangedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} items changed by others`)
};

const de_live_items_changed = /** @type {(inputs: Live_Items_ChangedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Elemente von anderen geändert`)
};

/**
* | output |
* | --- |
* | "{count} items changed by others" |
*
* @param {Live_Items_ChangedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const live_items_changed = /** @type {((inputs: Live_Items_ChangedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Items_ChangedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_live_items_changed(inputs)
	return en_live_items_changed(inputs)
});